import { AnimatedCamera } from '@/commons/camera/AnimatedCamera';
import { CustomTrackControls } from '@/commons/camera/controls/CustomTrackballControls';
import { ControlsOperation, type ICameraControls } from '@/commons/camera/controls/ICameraControls';
import type { TCameraParams } from '@/commons/camera/TCameraParams';

class TrackballCamera extends AnimatedCamera {
    protected createControls(rendererDomElement: HTMLCanvasElement): ICameraControls {
        return new CustomTrackControls(this, rendererDomElement);
    }

    constructor(cameraParams: TCameraParams) {
        super(cameraParams);
        this.initializeControls();
        this.controls.addMouseAction(ControlsOperation.ZOOM, 'WHEEL');
        this.controls.addMouseAction(ControlsOperation.ROTATE, 0);
    }
}

export { TrackballCamera };
